module.exports = "/_next/static/images/errorDark-5815ca889c8a57e36a3a9368520a53fe.svg";